"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  background: 'linear-gradient(to top, #fff 20%, rgba(255,255,255,0.9) 30%)',
  bottom: 0,
  boxSizing: 'border-box',
  justifySelf: 'flex-end',
  padding: theme.spacing(3),
  position: 'absolute',
  width: '100%',
  zIndex: 2
}));
